import styled from "styled-components";

interface IButtonLinkUnderscoreProps{
  color?: string
}

const ButtonLinkUndescore = styled.button<IButtonLinkUnderscoreProps>`
  background: none;
  font-size: 14px;
  border: none;
  color: ${props => props.color || '#fff'};
  text-decoration: underline;
  cursor: pointer;
  width: 100%;
  font-weight: 700;
  margin-top: 8px;
`
export default ButtonLinkUndescore